import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import EntityCrudService from 'app/blocks/service/api/entity-service';
import {Resource} from 'app/constants/resource';
import {ITranslation, Translation} from 'app/blocks/model/translation.model';
import {SERVER_API_URL} from 'app/app.constants';
import {TranslationSettings} from '@fuse/services/translation-loader.service';
import {SuperUserService} from 'app/core/auth/super-user.service';

@Injectable({
    providedIn: 'root'
})
export class TranslationService extends EntityCrudService<ITranslation> {
    translations: any[] = [];
    private _translationsLoaded = false;

    constructor(
        http: HttpClient,
        private superUserService: SuperUserService
    ) {
        super(http, Resource.TRANSLATION, (obj?) => new Translation(obj));
    }

    waitForTranslationsToLoad = async (): Promise<void> => {
        if (this._translationsLoaded) {
            return;
        }

        const response = await this.getTranslation();
        for (const item of response) {
            TranslationSettings.TRANSLATION_SETTINGS[item.key] = item.value;
        }
        this.translations = response;
        this._translationsLoaded = true;
    };

    getTranslationForKey = (key: string): any => {
        return this.translations.find((translation) => translation.key === key)?.value ?? null;
    };

    getTranslation = (): Promise<any> => {
        // Translations are tenant-scoped; a super admin has no tenant schema, so this
        // endpoint 500s for them. Skip the call entirely for super admins.
        if (this.superUserService.getIsSuperUser()) {
            return Promise.resolve([]);
        }
        return this.http.get<any>(SERVER_API_URL + `api/translation/all`).toPromise();
    };
}
